/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';
import AbstractCreateReviewButton from './AbstractCreateReviewButton';

/**
 * The "write a review" entry in an ArticleActionButtons row — article slider items and the
 * literary work page. The inner markup is orell-articles': it styles those classes, and this
 * button has to render them to sit level with the row's others.
 */
export default class CreateReviewActionButton extends AbstractCreateReviewButton {
	view() {
		return (
			<Button className="Button Button-ArticleActionButtons" onclick={() => this.start()} disabled={!this.allowed()}>
				<div className="ArticleActionButton-icon">{icon('fas fa-heart')}</div>
				<span className="ArticleActionButton-label">{this.label()}</span>
			</Button>
		);
	}
}
